import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { PRIVATE_ROUTES } from '../../../../../Routes/routes'
import courseHutritClubImage from '../../../../../assets/course-hutrit-club-image.jpeg'
import './HutritClubAcademyStage.css'

const HutritClubAcademyStage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [imageFailed, setImageFailed] = useState(false)
  const [imageLoaded, setImageLoaded] = useState(false)

  return (
    <section className="club-stage text-on-bg-primary" aria-labelledby="club-academy-title">
      <header className="club-stage__header">
        <span className="club-stage__eyebrow">{t('your_next_step')}</span>
        <h2 id="club-academy-title" className="club-stage__title">
          {t('academy_stage_title')}
        </h2>
        <p className="club-stage__subtitle">{t('academy_stage_subtitle')}</p>
      </header>

      {!imageFailed && (
        <div className="club-stage__content">
          <div className="club-stage__media">
            <img
              src={courseHutritClubImage}
              alt={t('academy_stage_image_alt')}
              className={`club-stage__img ${imageLoaded ? 'club-stage__img--loaded' : ''}`}
              loading="eager"
              decoding="async"
              onLoad={() => setImageLoaded(true)}
              onError={() => setImageFailed(true)}
            />
          </div>
        </div>
      )}

      <footer className="club-stage__footer">
        <button
          type="button"
          className="club-stage__cta"
          onClick={() => navigate(PRIVATE_ROUTES.academy)}
        >
          {t('go_to_academy')}
          <span aria-hidden="true" className="club-stage__cta-arrow">
            →
          </span>
        </button>
      </footer>
    </section>
  )
}

export default HutritClubAcademyStage
